import { Injectable } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Moment } from 'moment';
import * as _moment from 'moment';
import {
  ASSURANCE_LIFE_VA,
  ASSURANCE_LIFE_VF,
  ASSURANCE_LIFE_VP,
  ASSURANCE_TOTAL_PROTECTION_PA,
  ASSURANCE_TOTAL_PROTECTION_PC,
  CONTACT_DATA,
  DIRECT_DEBIT,
  FINANCE,
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  HOLDER_DATA,
  INSURANCE,
  INTERVINIENTE_1_DIRECT_DEBIT,
  INTERVINIENTE_1_CONTACT_DATA,
  REQUEST_DATA,
  SOCIOECONOMIC_DATA,
  ASSURANCE_LIFE_MAX_AGE,
  ASSURANCE_TOTAL_MAX_AGE,
  ASSURANCE_PAYMENT_MAX_AGE,
  ASSURANCE_MIN_AGE,
} from '@app/@core/constants/requests.constants';
import { TypeVehicleReturnDTO } from '@app/requests/model/combos-model';
import { LOCALE_DE, LOCALE_ES } from '@app/@core/constants/common.constants';

const moment = _moment;
const LENGHT_CONTRACT = 7;
const LENGHT_OPERATION = 15;

@Injectable({ providedIn: 'root' })
export class CustomValidatorsService {
  constructor() {}

  public isAssuranceValid(request_type: string, listaFormularios: FormGroup[]): string {
    let insurance: string, term: string, birthday: any, sitLaboral: string, age: number, message: string;
    birthday = listaFormularios[HOLDER_DATA].controls.birthDate.value;

    if (!(birthday instanceof Date)) {
      birthday = birthday.toDate();
    }

    sitLaboral = listaFormularios[SOCIOECONOMIC_DATA].controls.laboralSituation.value;
    if (request_type === FORM_AUTO || request_type === FORM_CONSUMO) {
      insurance = listaFormularios[FINANCE].controls.finance.value?.insurance;
      term = listaFormularios[REQUEST_DATA].controls.term.value;
    } else {
      insurance = listaFormularios[INSURANCE].controls.insuranceSelect.value;
    }
    if (birthday && insurance) {
      const today = moment();
      age = today.toDate().getFullYear() - birthday.getFullYear();

      if (request_type !== FORM_BP && term) {
        age = age + parseInt(term) / 12;
      }
      const months = today.toDate().getMonth() - birthday.getMonth();
      if (months > 0 || (months === 0 && birthday.getDate() < today.toDate().getDate())) {
        age--;
      }
    }
    if (
      (insurance === ASSURANCE_LIFE_VA || insurance === ASSURANCE_LIFE_VF || insurance === ASSURANCE_LIFE_VP) &&
      (age < ASSURANCE_MIN_AGE || age >= ASSURANCE_LIFE_MAX_AGE)
    ) {
      message = 'dialog.test.error.birthday';
    } else if (insurance === ASSURANCE_TOTAL_PROTECTION_PA || insurance === ASSURANCE_TOTAL_PROTECTION_PC) {
      if (age < ASSURANCE_MIN_AGE || age >= ASSURANCE_TOTAL_MAX_AGE) {
        message = 'dialog.test.error.birthday.protection';
      } else if (
        sitLaboral &&
        sitLaboral !== '01' &&
        sitLaboral !== '02' &&
        sitLaboral !== '03' &&
        sitLaboral !== '04'
      ) {
        message = 'dialog.test.error.sitLaboral';
      }
    } else if (
      request_type === FORM_BP &&
      insurance === 'S' &&
      (age < ASSURANCE_MIN_AGE || age >= ASSURANCE_PAYMENT_MAX_AGE)
    ) {
      message = 'dialog.test.error.birthday.card';
    }
    return message;
  }

  //validaciones requests
  public numberOnly(charCode: any, valueInput: any): boolean {
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      if (charCode === 44) {
        //ya hay una coma o punto, no se pueden poner mas
        if (valueInput.includes(',') || valueInput.includes('.')) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
    return true;
  }

  //validaciones requests
  public lettersOnly(charCode: any): boolean {
    const specialCharactersCode = [
      192,
      193,
      199,
      200,
      201,
      204,
      205,
      209,
      210,
      211,
      217,
      218,
      224,
      225,
      231,
      232,
      233,
      236,
      237,
      241,
      242,
      243,
      249,
      250,
      252,
    ];
    //ü,á,é,í,ó,ú,Á,É,Í,Ó,Ú,ñ,Ñ,à,è,ì,ò,ù,À,È,Ì,Ò,Ù,ç,Ç
    // - => 45
    if (charCode < 32 || (charCode > 32 && charCode < 65) || (charCode > 90 && charCode < 97) || charCode > 122) {
      if ((charCode > 122 && specialCharactersCode.includes(charCode)) || charCode == 45) {
        return true;
      }
      return false;
    }
    return true;
  }

  //validaciones requests
  public alphanumericHyphenBackslash(charCode: any, valueInput: any): boolean {
    if (
      charCode < 32 ||
      (charCode > 32 && charCode < 45) ||
      (charCode > 45 && charCode < 47) ||
      (charCode > 57 && charCode < 65) ||
      (charCode > 90 && charCode < 97) ||
      charCode > 122
    ) {
      return false;
    }
    return true;
  }

  public alphanumericOnly(charCode: any, valueInput: any): boolean {
    if (
      charCode < 32 ||
      (charCode > 32 && charCode < 48) ||
      (charCode > 57 && charCode < 65) ||
      (charCode > 90 && charCode < 97) ||
      charCode > 122
    ) {
      return false;
    }
    return true;
  }

  public validateNameAndSurname(value: string): boolean {
    //la regexp admite letras mayúsculas y minúsculas, con y sin tildes, ñ y Ñ, y permite 2 espacios en blanco
    const regExp = /^([a-zA-ZÑÁÉÍÓÚÀÈÌÒÙÇÜÏñáéíóúàèìòùçüï][a-zA-ZÑÁÉÍÓÚÀÈÌÒÙÇÏÜñáéíóúàèìòùçïü]{0,60}[\-\']{0,1}[\s]{0,1}){1,10}$/;

    return regExp.test(value);
  }

  public validateAlphanumericAndSpecialChars(value: string) {
    const regExp = /^[ A-Za-z0-9-/]*$/; //Validate special symbols such as: ' ', '-' and '/'
    return new RegExp(regExp).test(value) ? value : '';
  }

  public isAlphanumericValid(c: AbstractControl): { [key: string]: boolean } | null {
    const regExp = /^[a-zA-Z0-9]*$/;
    return c.dirty && !new RegExp(regExp).test(c?.value) ? { alphanumericInvalid: true } : null;
  }

  public transformAmount(value: any): string {
    var regExp = /[a-zA-Z]/g;

    //si está vacío devolvemos vacío
    if (value == '') return value;
    //si contiene una letra devolvemos vacío
    if (regExp.test(value)) return '';

    let formattedAmount: string;
    let decimalAmount: string;
    let valueNoPoint: string = value.replace('.', '');

    if (valueNoPoint.includes(',')) {
      decimalAmount = valueNoPoint.replace(',', '.');
    } else {
      decimalAmount = valueNoPoint;
    }

    let amountNumber: number = parseFloat(decimalAmount);
    if (isNaN(amountNumber)) return '';
    //Si ponemos "es-ES" como locale no pone los puntos de los miles
    formattedAmount = new Intl.NumberFormat(LOCALE_DE, {
      style: 'currency',
      currency: 'EUR',
    }).format(amountNumber);

    return formattedAmount;
  }

  public isRequestedAmountAutosValid(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      const priceVehicle = c.get('priceVehicle');
      const requestedAmount = c.get('requestedAmount');
      const start = c.get('start');

      let isInvalid = null;

      if (priceVehicle.dirty || requestedAmount.dirty) {
        if (priceVehicle.value !== '' && requestedAmount.value !== '') {
          isInvalid = { requestedAmountInvalid: true };
          requestedAmount.setErrors({ requestedAmountInvalid: true });

          let priceVehicleFormatted;
          let requestedAmountFormatted;

          priceVehicleFormatted = parseFloat(priceVehicle.value?.toString().replaceAll('.', '').replace(',', '.'));
          requestedAmountFormatted = parseFloat(
            requestedAmount.value?.toString().replaceAll('.', '').replace(',', '.')
          );

          if (!isNaN(priceVehicleFormatted) && !isNaN(requestedAmountFormatted)) {
            let startTotal: number = priceVehicleFormatted - requestedAmountFormatted;
            if (startTotal >= 0) {
              let formattedStart = new Intl.NumberFormat(LOCALE_ES, {
                style: 'currency',
                currency: 'EUR',
              }).format(startTotal);
              if (formattedStart.substring(0, formattedStart.indexOf(',')).length === 4) {
                formattedStart = [formattedStart.slice(0, 1), '.', formattedStart.slice(1)].join('');
              }
              if (start && start.value !== formattedStart) {
                start.setValue(formattedStart);
              }
              isInvalid = null;
              requestedAmount.setErrors(null);
              priceVehicle.setErrors(null);
            }
          } else if (!isNaN(priceVehicleFormatted) && isNaN(requestedAmountFormatted)) {
            priceVehicle.setErrors(null);
          } else if (isNaN(priceVehicleFormatted) && !isNaN(requestedAmountFormatted)) {
            requestedAmount.setErrors(null);
          }
        } else {
          if (requestedAmount.value == '') requestedAmount.setErrors({ required: true });
          if (priceVehicle.value == '') priceVehicle.setErrors({ required: true });
        }
      }
      return isInvalid;
    };
  }

  //Custom made for search panel
  public isDateValid(firstControl: string, secondControl: string, error: string): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let isInvalid = null;
      const initialDate = c.get(firstControl);
      const finalDate = c.get(secondControl);

      if (this.checkInvalidDates(initialDate, finalDate)) {
        isInvalid = { [error]: true };
        initialDate.setErrors(isInvalid);
        finalDate.setErrors(isInvalid);
      } else {
        isInvalid = null;
        if (initialDate && finalDate) {
          initialDate.updateValueAndValidity({ onlySelf: true, emitEvent: false });
          finalDate.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
      }

      return isInvalid;
    };
  }

  public checkIsFutureDate(c: AbstractControl): { [key: string]: boolean } | null {
    let today = new Date();
    let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    lastDayOfMonth.setHours(23, 59, 59, 999);
    return c.dirty && c.value?.valueOf() > lastDayOfMonth.getTime() ? { dateFuture: true } : null;
  }

  private checkInvalidDates(firstControl: AbstractControl, secondControl: AbstractControl) {
    return (
      firstControl &&
      secondControl &&
      firstControl.dirty &&
      secondControl.dirty &&
      firstControl.value &&
      secondControl.value &&
      firstControl.value > secondControl.value
    );
  }

  public isDateRangeOneYear(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      const initialDate = c.get('initialDate');
      const finalDate = c.get('finalDate');
      let startDate = new Date(initialDate?.value);
      let endDate = new Date(finalDate?.value);
      let isInvalid = null;
      startDate.setFullYear(startDate.getFullYear() + 1);
      if (startDate < endDate) {
        isInvalid = { dateInvalidYear: true };
      } else {
        initialDate.setErrors(null);
        finalDate.setErrors(null);
      }
      return isInvalid;
    };
  }

  public isAntiquityValid(c: AbstractControl): { [key: string]: boolean } | null {
    const datePicked = c.value;
    const currentMoment = moment();
    return datePicked ? (datePicked > currentMoment ? { antiquityValid: true } : null) : null;
  }

  public isTelephoneValid(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp('^[67]\\d{8}$');
    return c && c.dirty && c.value?.length > 0 && !regex.test(c.value) ? { telephoneInvalid: true } : null;
  }

  public isPhoneValid(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp('^[6789]\\d{8}$');
    return c && c.dirty && c.value?.length > 0 && !regex.test(c.value) ? { telephoneInvalid: true } : null;
  }

  public islandlineValid(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp('^[98]\\d{8}$');
    return c && c.dirty && c.value?.length > 0 && !regex.test(c.value) ? { islandlineValid: true } : null;
  }

  public validateEmail(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$');
    return c.dirty && c && c.value?.length > 0 && !regex.test(c.value) ? { emailInvalid: true } : null;
  }

  public validateText(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp(/^[0-9a-zA-Z]+$/);
    return c.dirty && c && !regex.test(c.value) ? { textInvalid: true } : null;
  }

  public validateNumber(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp(/^([0-9])*$/);
    return c.dirty && c && !regex.test(c.value) ? { numberInvalid: true } : null;
  }

  public validatePostalCode(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp(/^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/);
    return c.dirty && c && !regex.test(c.value) ? { numberInvalid: true } : null;
  }

  public isValidStructureIBAN(c: AbstractControl): { [key: string]: boolean } | null {
    const regex = new RegExp(/[a-zA-Z]{2}[0-9]{22}$/);
    return c.dirty && c && !regex.test(c.value) ? { numberCreditAccountInvalid: true } : null;
  }

  public isBirthdayValid(c: AbstractControl): { [key: string]: boolean } | null {
    let dateInput = new Date(c.value);
    let dateTime = new Date();
    return c.pristine || c.value === '' || c.value === null || dateInput > dateTime ? { birthdayInvalid: true } : null;
  }

  public isNifOrCifValid(c: AbstractControl): { [key: string]: boolean } | null {
    let numero, caracter, letra, value;
    let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;
    let expresion_regular_cif = /^[ABCDEFGHJKLMNPQRSUVW]{1}[0-9]{7}[a-zA-Z0-9]{1}$/;
    var expresion_regular_nie = /^[XYZ]\d{7,8}[A-Z]$/;

    value = c.value?.toUpperCase() || '';

    if (expresion_regular_cif.test(value) == true) {
      //validar letra cif por separado
      let l_valor = value;
      let pNumDocumento = value;
      let bRetorno = false;

      let v1 = new Array(0, 2, 4, 6, 8, 1, 3, 5, 7, 9);
      let temp = 0;
      let F: string = l_valor;

      let dc = l_valor.substring(8, 9);

      if (dc == '0') {
        dc = '10';
      }

      for (let i = 2; i <= 6; i += 2) {
        temp = temp + v1[parseInt(F.substring(i - 1, i))];
        temp = temp + parseInt(F.substring(i, i + 1));
      }

      temp = temp + v1[parseInt(F.substring(7, 8))];
      temp = 10 - (temp % 10);

      if (pNumDocumento.charAt(pNumDocumento.length - 1) == String.fromCharCode(64 + temp)) {
        bRetorno = true;
      } else {
        if (temp == dc) bRetorno = true;
        else bRetorno = false;
      }

      return c.value && c.dirty && !bRetorno ? { dniInvalid: true } : null;
    } else if (expresion_regular_nie.test(value) || expresion_regular_dni.test(value) == true) {
      numero = value.substr(0, value.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      caracter = value.substr(value.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);

      return c.value && c.dirty && letra != caracter ? { dniInvalid: true } : null;
    } else {
      return c.value && c.dirty ? { dniInvalid: true } : null;
    }
  }

  public isNifNieValid(c: AbstractControl): { [key: string]: boolean } | null {
    let numero, caracter, letra, dni;
    let expresion_regular_dni = /^(\d{8})([A-Z])$/;
    let expresion_regular_nie = /^([X-Z]){1}((\d){7})([A-Z]{1})$/;

    dni = c.value?.toUpperCase() || '';

    if (expresion_regular_dni.test(dni) || expresion_regular_nie.test(dni)) {
      numero = dni.substr(0, dni.length - 1);
      numero = numero.replace('X', 0);
      numero = numero.replace('Y', 1);
      numero = numero.replace('Z', 2);
      caracter = dni.substr(dni.length - 1, 1);
      numero = numero % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(numero, numero + 1);

      return c.value && c.dirty && letra != caracter ? { dniInvalid: true } : null;
    } else {
      return c.value && c.dirty ? { dniInvalid: true } : null;
    }
  }

  public isValidCIF(c: AbstractControl): { [key: string]: boolean } | null {
    let l_valor = c.value.toUpperCase();
    let pNumDocumento = c.value.toUpperCase();
    let bRetorno = true;

    if (c.value && c.dirty && l_valor.length == 9) {
      if (!/^[ABCDEFGHJPQRSUVNW]/.test(l_valor)) {
        //es un NIE
        bRetorno = false;
      } else {
        let v1 = new Array(0, 2, 4, 6, 8, 1, 3, 5, 7, 9);
        let temp = 0;
        let F: string = l_valor;

        let dc = l_valor.substring(8, 9);

        if (dc == '0') {
          dc = '10';
        }

        for (let i = 2; i <= 6; i += 2) {
          temp = temp + v1[parseInt(F.substring(i - 1, i))];
          temp = temp + parseInt(F.substring(i, i + 1));
        }

        temp = temp + v1[parseInt(F.substring(7, 8))];
        temp = 10 - (temp % 10);

        if (pNumDocumento.charAt(pNumDocumento.length - 1) == String.fromCharCode(64 + temp)) {
          bRetorno = true;
        } else {
          if (temp == dc) bRetorno = true;
          else bRetorno = false;
        }
      }
    }
    return c.value && c.dirty && !bRetorno ? { shouldbecif: true } : null;
  }

  public isNIFAutonomo(dni: string, dniHolder: string): { [key: string]: boolean } | null {
    if (dni != null && dni !== '') {
      return dniHolder != dni ? { nifautonomo: true } : null;
    } else {
      return null;
    }
  }

  public isNIFNoAutonomo(dni: string, dniHolder: string): { [key: string]: boolean } | null {
    return dniHolder == dni ? { nifigualcif: true } : null;
  }

  public isNie(dni: string): boolean {
    let isNie = /^[XYZ]\d{7}[A-Z]$/.test(dni);

    return isNie;
  }

  public isSpanishNIF(value: string): boolean {
    let regexCif = new RegExp(/^[0-9]{8}[a-zA-Z0-9]{1}$/);
    return regexCif.test(value);
  }

  //the field cif should admit CIF, NIE and NIF
  // public isCifNifValid(c: AbstractControl): { [key: string]: boolean } | null {
  //   let regexDni = new RegExp(/^\d{8}[a-zA-Z]$/);
  //   let regexNie = new RegExp(/^[xXyYzZ]\d{7,8}[a-zA-Z]$/);
  //   let regexCif = new RegExp(/^[a-zA-Z]{1}\d{7}[a-zA-Z0-9]{1}$/);

  //   return regexCif.test(c.value) || regexNie.test(c.value) || regexDni.test(c.value) ? null : { dniInvalid: true };
  // }

  public isMangoEmployeeCodeValid(c: AbstractControl): { [key: string]: boolean } | null {
    let regexMg = new RegExp(/^\d{0,9}$/);
    return c.value && c.dirty && !regexMg.test(c.value) ? { employeeCodeInvalid: true } : null;
  }

  public isOwnerMoreThanOneValid(intervinientes: number, requests: FormGroup[]): boolean {
    let contador = 0;
    if (requests[DIRECT_DEBIT].controls.ownershipCombo?.value === 'T') {
      contador++;
    }
    if (intervinientes > 0 && requests) {
      for (
        let index = INTERVINIENTE_1_DIRECT_DEBIT, interviniente = 1;
        interviniente <= intervinientes;
        index = index + 4, interviniente++
      ) {
        if (requests[index].controls.ownershipCombo?.value === 'T') {
          contador++;
          if (contador === 2) {
            return false;
          }
        }
      }
    }
    return true;
  }

  public isOwnerValid(intervinientes: number, requests: FormGroup[]): boolean {
    if (requests[DIRECT_DEBIT].controls.ownershipCombo?.value === 'T') {
      return true;
    } else if (intervinientes > 0 && requests) {
      for (
        let index = INTERVINIENTE_1_DIRECT_DEBIT, interviniente = 1;
        interviniente <= intervinientes;
        index = index + 4, interviniente++
      ) {
        if (requests[index].controls.ownershipCombo?.value === 'T') {
          return true;
        }
      }
    } else {
      return false;
    }
  }

  public isMoreThanAYearApart(
    firstControl: string,
    secondControl: string,
    error: string,
    hasDays?: boolean
  ): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      let isInvalid = null;
      const initialDate = c.get(firstControl);
      const finalDate = c.get(secondControl);
      if (
        initialDate &&
        finalDate &&
        initialDate.dirty &&
        finalDate.dirty &&
        initialDate.value &&
        finalDate.value &&
        finalDate.value.diff(initialDate.value, 'months', hasDays) >= 12
      ) {
        isInvalid = { [error]: true };
        initialDate.setErrors(isInvalid);
        finalDate.setErrors(isInvalid);
      } else {
        isInvalid = null;
        if (initialDate && finalDate && !c.errors) {
          initialDate.updateValueAndValidity({ onlySelf: true, emitEvent: false });
          finalDate.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        }
      }
      return isInvalid;
    };
  }

  public checkNoEmailNoPhone(intervinientes: number, requests: FormGroup[]): boolean {
    if (requests[CONTACT_DATA].controls.noemail?.value || requests[CONTACT_DATA].controls.nophone?.value) {
      return false;
    } else if (intervinientes > 0 && requests) {
      for (
        let index = INTERVINIENTE_1_CONTACT_DATA, interviniente = 1;
        interviniente <= intervinientes;
        index = index + 4, interviniente++
      ) {
        if (requests[index].controls.noemail?.value || requests[index].controls.nophone?.value) {
          return false;
        }
      }
      return true;
    } else {
      return true;
    }
  }

  public isCarRegistrationValid(c: AbstractControl): { [key: string]: boolean } | null {
    let regexCarReg = new RegExp(/^[a-zA-Z0-9]{7}$|^$/);

    return c.dirty && c.value && !regexCarReg.test(c.value) ? { RegistrationCarInvalid: true } : null;
  }

  public isCarRackValid(c: AbstractControl): { [key: string]: boolean } | null {
    let regexCarRack = new RegExp(/^[a-zA-Z0-9]{17}$|^$/);

    return c.dirty && c.value && !regexCarRack.test(c.value) ? { RackInvalid: true } : null;
  }

  public isAntCarValid(typeVehicle: TypeVehicleReturnDTO): ValidatorFn {
    return (c: AbstractControl): { [key: string]: any } | null => {
      return c?.value ? this.getNumMonths(moment(c.value).format('MM/YYYY'), +typeVehicle.monthmax) : null;
    };
  }

  private getNumMonths(date: string, maxMonths: number): { [key: string]: boolean } | null {
    const today = moment().format('MM/YYYY');
    const dateInputYear = +date.split('/')[1];
    const dateInputMonth = +date.split('/')[0];

    let calculatedDateYear = +today.split('/')[1];
    let calculatedDateMonth = +today.split('/')[0];

    while (maxMonths > 0) {
      if (calculatedDateMonth === 0) {
        --calculatedDateYear;
        calculatedDateMonth = 12;
      }
      --calculatedDateMonth;
      --maxMonths;
    }

    return dateInputYear < calculatedDateYear ||
      (dateInputYear === calculatedDateYear && dateInputMonth < calculatedDateMonth)
      ? { antCarInvalid: true }
      : null;
  }

  public isInitialDateAndFinalDateValid(): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      const initialDate = c.get('initialDate');
      const finalDate = c.get('finalDate');
      let isInvalid = null;
      if (initialDate?.dirty && finalDate?.dirty && initialDate.value && finalDate.value) {
        const monthsDiff = finalDate.value.diff(initialDate.value, 'months', true);
        if (monthsDiff > 0 && monthsDiff <= 12) {
          if (initialDate.hasError('dateInvalid') || finalDate.hasError('dateInvalid')) {
            initialDate.setErrors(null);
            finalDate.setErrors(null);
          }
        } else {
          if (!initialDate.hasError('dateInvalid') || !finalDate.hasError('dateInvalid')) {
            initialDate.setErrors({ dateInvalid: true });
            finalDate.setErrors({ dateInvalid: true });
            isInvalid = { dateInvalid: true };
          }
        }
      }
      return isInvalid;
    };
  }

  public isOperationValid(c: AbstractControl): { [key: string]: boolean } | null {
    return c.dirty && c.value && c.value?.length !== LENGHT_OPERATION && c.value?.length !== LENGHT_CONTRACT
      ? { numOperationInvalid: true }
      : null;
  }

  public isContractValid(c: AbstractControl): { [key: string]: boolean } | null {
    return c.dirty && c.value && c.value?.length !== LENGHT_CONTRACT ? { numContractInvalid: true } : null;
  }

  public isSolValid(c: AbstractControl): { [key: string]: boolean } | null {
    return c.dirty && c.value && c.value?.length !== LENGHT_OPERATION ? { numSolInvalid: true } : null;
  }

  isRequired = (c: AbstractControl): { [key: string]: boolean } | null => {
    if (c) {
      const value = c.value;
      return !value || (c.dirty && value === 'undefined') ? { required: true } : null;
    } else console.error('Custom validators - isRequired: Couldn`t find the control');
  };
}
